import React from 'react'
import { Box, Skeleton, Stack, useTheme } from '@mui/material'

export const ProcessSkeleton: React.FC = () => {
  const theme = useTheme()
  
  return (
    <Box
      sx={{
        width: '100%',
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: 3,
        overflow: 'hidden'
      }}
    >
      <Stack direction="row">
        {Array.from({ length: 5 }, (_, index) => (
          <Stack 
            key={index}
            sx={{ 
              flex: 1,
              borderRight: index < 4 ? `1px solid ${theme.palette.grey[200]}` : 'none'
            }}
          >
            <Stack 
              direction="row" 
              alignItems="center" 
              justifyContent="center" 
              gap={1}
              sx={{
                padding: 2,
                borderBottom: `1px solid ${theme.palette.grey[200]}`,
                minHeight: 56
              }}
            >
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="circular" width={14} height={14} />
            </Stack>
            
            <Stack sx={{ flex: 1, padding: 2 }}>
              {Array.from({ length: 2 }, (_, cellIndex) => (
                <Stack 
                  key={cellIndex}
                  alignItems="center" 
                  justifyContent="center" 
                  sx={{ 
                    height: 100,
                    gap: 0.5,
                    borderBottom: cellIndex < 1 ? `1px solid ${theme.palette.grey[100]}` : 'none'
                  }}
                >
                  <Skeleton variant="text" width={'60%'} height={12} />
                  <Skeleton variant="text" width={'40%'} height={10} />
                  <Skeleton variant="circular" width={16} height={16} />
                </Stack>
              ))}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}